module.exports = __webpack_public_path__ + "img/12.c5c79616.jpg";